import { render, staticRenderFns } from "./UtilFile.vue?vue&type=template&id=bdb3a660"
import script from "./UtilFile.vue?vue&type=script&lang=js"
export * from "./UtilFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports